import { render, staticRenderFns } from "./ResourceDrawer.vue?vue&type=template&id=4705fc8a&scoped=true"
import script from "./ResourceDrawer.vue?vue&type=script&lang=js"
export * from "./ResourceDrawer.vue?vue&type=script&lang=js"
import style0 from "./ResourceDrawer.vue?vue&type=style&index=0&id=4705fc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705fc8a",
  null
  
)

export default component.exports